import './Slider.css';
import img0 from '../../assets/VdHR©lisa_hinder_337.jpg';
import img1 from '../../assets/VdHR©lisa_hinder_032.jpg';
import img2 from '../../assets/VdHR©lisa_hinder_121.jpg';
import img3 from '../../assets/VdHR©lisa_hinder_156.jpg';
import { useEffect, useState } from 'react';

const imgArr = [img0, img1, img2, img3];
const textArr = ['Radiokunst', 'Unterhaltung', 'Kulturgut', 'Hörgenuss'];

function Slider() {
  const [currentImg, setCurrentImg] = useState(imgArr[0]);
  const [nextImg, setNextImg] = useState(imgArr[1]);
  const [currentText, setCurrentText] = useState(textArr[0]);
  const [nextText, setnextText] = useState(textArr[1]);
  const [count, setCount] = useState(0);
  const [animateImg, setAnimateImg] = useState(false);

  const countUp = () => {
    setCount((count + 1) % 4);
  };

  useEffect(() => {
    setCurrentImg(imgArr[count]);
    setNextImg(imgArr[(count + 1) % 4]);
    setCurrentText(textArr[count]);
    setnextText(textArr[(count + 1) % 4]);
    sliding();
  }, [count]);

  function timeout(ms) {
    return new Promise((res) => setTimeout(res, ms));
  }

  const sliding = async () => {
    await timeout(1000);
    setAnimateImg(true);
    await timeout(5000);
    setAnimateImg(false);
    countUp();
  };

  useEffect(() => {}, []);
  return (
    <>
      <div className="sliderImgDiv">
        <div
          className="sliderImg currentImg"
          style={{ backgroundImage: `url( ${currentImg} )` }}
        >
          <h1>{currentText}</h1>
        </div>
        <div
          className={animateImg ? 'animateImg sliderImg' : 'hideImg'}
          style={{ backgroundImage: `url( ${nextImg} )` }}
        >
          <h1>{nextText}</h1>
        </div>
      </div>
    </>
  );
}

export default Slider;
